import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'docs' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
